import PayloadStrategy from "./PayloadStrategy";

class Process extends PayloadStrategy {
	constructor(process) {
		super();

		this.report_type = process.report_type || "";
		this.date_init = process.date_init || null;
		this.date_end = process.date_end || null;
		this.resource_id = process.resource_id || null;

		this.id = process.id || null;
		this.added_on = process.added_on || null;
		this.update_on = process.update_on || null;
		this.total_download_file = process.total_download_file || 0;
		this.download_file_id = process.download_file_id || null;
	}

	validate() {
		if (!this.report_type) return "report_type";
		if (!this.date_init) return "date_init";
		if (!this.date_end) return "date_end";
		if (!this.resource_id) return "resource_id";
		return null;
	}

	payloadToCreate() {
		return {
			report_type: this.report_type,
			date_init: this.date_init,
			date_end: this.date_end,
			resource_id: this.resource_id,
		};
	}

	payloadToUpdate() {
		return {
			report_type: this.report_type,
			date_init: this.date_init,
			date_end: this.date_end,
			resource_id: this.resource_id,
		};
	}

	payloadToFetch() {
		return [
			"id",
			"report_type",
			"date_init",
			"date_end",
			"resource_id",
			"added_on",
			"update_on",
			"total_download_file",
			"download_file_id",
		];
	}
}

export default Process;
